import { Component, OnInit, Input, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { IPopoverContent } from '../../models';
import { AppConstants } from '../../config';


@Component({
	selector: 'popover-component',
	templateUrl: './popover.component.html',
	imports: [CommonModule, TranslateModule, NgbPopoverModule]
})
export class PopoverComponent implements OnInit, OnDestroy {
	_content: IPopoverContent[];
	@Input() triggers = 'manual';
	@Input() translateValue = false;
	@Input() centerText = true;
	@Input() labelClassName = '';
	@Input() fontSize = '';
	@Input() icon = 'fa-info-circle';
	@Input() disabled = false;
	@Input() btnClass = 'btn';

	// If you bind click to triggers and use event.stopPropagation(), popover will not show => for click, just don't bind anything as it's the default
	// If clicking the icon opens a modal, do not bind focus to triggers (or else the popover re-shows after closing the modal)
	@Output() clicked = new EventEmitter();
	@Output() shown = new EventEmitter();
	@Output() hidden = new EventEmitter();

	isOnClickUsed = false;

	@ViewChild('popover', { static: true }) popover;

	get content() {
		return this._content;
	}

	@Input()
	set content(value: IPopoverContent[] | string) {
		if (typeof value === 'string') this._content = [{value}];
		else this._content = value;
	}

	opened: boolean;

	scrollableSelector = [
		// popovers should disappear on page scroll
		typeof AppConstants.ANIMATED_SCROLL_ELEMENT_DEFAULT === 'string' ? AppConstants.ANIMATED_SCROLL_ELEMENT_DEFAULT : null,
		// and within fixed-height tables
		'.table-fixed-height-wrapper'
	].filter(Boolean).join(',');
	scrollElements: HTMLElement[] = [];

	ngOnInit() {
		this.isOnClickUsed = this.clicked.observers.length > 0;
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	protected fontSizeClassName(text: string): string[] {
		if (this.fontSize && ['sm', 'md'].includes(this.fontSize)) return [`popover-content-text-${this.fontSize}`];

		return [`popover-content-text-${text?.length > 150 ? 'sm' : 'md'}`];
	}

	private installListeners() {
		if (this.opened) return;
		this.scrollElements = [].slice.call(document.querySelectorAll(this.scrollableSelector));
		this.scrollElements.forEach(el => el.addEventListener('scroll', this.onScroll));
	}

	private removeListeners() {
		this.scrollElements.forEach(el => el.removeEventListener('scroll', this.onScroll));
	}

	private onScroll = () => {
		this.popover.close();
	}

	private togglePopover(popover) {
		document.body.click(); // Necessary trick to trigger the autoclose of the popover already opened
		if (popover.isOpen()) {
			popover.close();
		} else {
			popover.open();
			this.installListeners();
			this.opened = true
		}
	}

	protected onButtonClicked(event: Event, popover) {
		this.clicked.emit(event);
		this.isOnClickUsed ? event.stopPropagation() : null;
		this.togglePopover(popover)
	}
}
